import React from 'react';
import { useNavigate } from 'react-router-dom';

const teamMembers = [
    {
        name: 'Ankit Mutpe',
        role: 'Founder & Director',
        img: '/Images/Ankit_photo.jpg',
        linkedin: 'http://linkedin.com/in/ankit-ajay-mudpe-27401a169',
        email: 'mailto:ankit@krishiyan.com',
    },
    {
        name: 'Priyadharshini',
        role: 'Founder & Director',
        img: '/Images/Priya.jpeg',
        linkedin: 'https://www.linkedin.com/in/priyadharsinispd/',
        email: 'mailto:priya@krishiyan.com',
    },
    {
        name: 'Murali',
        role: 'Web Developer',
        img: '/Images/Murali_photo.jpeg',
        linkedin: 'https://www.linkedin.com/in/murali-k-738935189/',
        email: 'mailto:info@krishiyan.com',
    },
];

export default function Team() {
    const navigate = useNavigate();

    return (
        <section id="team" className="bg-[#C0DDFF] py-12 px-4 sm:px-6 lg:px-24">
            <h1 className="text-2xl sm:text-3xl font-bold text-center">
                Team KrishiYan
            </h1>
            <div className="w-14 h-1 bg-[#616161] rounded-xl mx-auto mt-2 mb-8"></div>

            <div className="flex flex-wrap justify-center xl:gap-20 gap-8">
                {teamMembers.map((member) => (
                    <figure
                        key={member.name}
                        className="w-full sm:w-1/2 md:w-1/3 lg:w-1/4 flex flex-col items-center text-center p-4"
                    >
                        <img
                            src={member.img}
                            alt={member.name}
                            className="h-40 w-40 sm:h-48 sm:w-48 md:h-56 md:w-56 rounded-full object-cover outline outline-[10px] ring-[15px] ring-[#77CD94] outline-[#3FC041]"
                        />
                        <figcaption className="mt-4 text-lg font-semibold">
                            {member.name}
                        </figcaption>
                        <figcaption className="text-gray-800 mb-4">
                            {member.role}
                        </figcaption>
                        <div className="flex space-x-4">
                            <button
                                onClick={() => window.open(member.linkedin, '_blank')}
                                className="p-2 hover:opacity-80" type='button'
                            >
                                <img
                                    src="/Images/skill-icons_linkedin.png"
                                    alt="LinkedIn"
                                    className="h-6 w-6"
                                />
                            </button>
                            <button
                                onClick={() => window.open(member.email, '_blank')}
                                className="p-2 hover:opacity-80" type='button'
                            >
                                <img
                                    src="/Images/e-mail-filled.png"
                                    alt="Email"
                                    className="h-6 w-6"
                                />
                            </button>
                        </div>
                    </figure>
                ))}
            </div>
        </section>
    );
}